import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_GENERAL_SETTINGS_BOOKKEEPING = Symbol('general-settings.bookkeeping');

export const ADMIN_GENERAL_SETTINGS_BOOKKEEPING_ROUTE_NAME = Symbol('admin.settings.bookkeeping');
export const ADMIN_GENERAL_SETTINGS_BOOKKEEPING_LIST_ROUTE_NAME = Symbol('admin.settings.bookkeeping.list');
export const ADMIN_GENERAL_SETTINGS_BOOKKEEPING_UPDATE_ROUTE_NAME = Symbol('admin.settings.bookkeeping.update');

export const SETTINGS_BOOKKEEPING_CRUD_URL = 'admin/history_of_limit_changes';

export const SETTINGS_BOOKKEEPING_LIST_URL = `${SETTINGS_BOOKKEEPING_CRUD_URL}/list`;
export const SETTINGS_BOOKKEEPING_CREATE_URL = SETTINGS_BOOKKEEPING_CRUD_URL;
export const SETTINGS_BOOKKEEPING_UPDATE_URL = `${SETTINGS_BOOKKEEPING_CRUD_URL}/:id`;
export const SETTINGS_BOOKKEEPING_DELETE_URL = `${SETTINGS_BOOKKEEPING_CRUD_URL}/:id`;
export const SETTINGS_BOOKKEEPING_GET_ITEM_URL = `${SETTINGS_BOOKKEEPING_CRUD_URL}/:id/edit`;

export const SETTINGS_BOOKKEEPING_LIST_QUERY_KEY = 'general-settings.bookkeeping.list';
export const SETTINGS_BOOKKEEPING_CREATE_QUERY_KEY = 'general-settings.bookkeeping.create';
export const SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY = 'general-settings.bookkeeping.update';
export const SETTINGS_BOOKKEEPING_DELETE_QUERY_KEY = 'general-settings.bookkeeping.delete';
export const SETTINGS_BOOKKEEPING_GET_ITEM_QUERY_KEY = 'general-settings.bookkeeping.get-item';

export const ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS = {
  HISTORYOFLIMITCHANGES_CREATE: new Permission(
    PermissionsList.admin.HISTORYOFLIMITCHANGES_CREATE,
  ),
  HISTORYOFLIMITCHANGES_EDIT: new Permission(
    PermissionsList.admin.HISTORYOFLIMITCHANGES_EDIT,
  ),
  HISTORYOFLIMITCHANGES_DELETE: new Permission(
    PermissionsList.admin.HISTORYOFLIMITCHANGES_DELETE,
  ),
};
